import React, { useRef } from 'react'
import { CloseButton, ModalHeader } from '../../components/Template/Modal'
import useSize from '../../hooks/useSize'
import { useTranslation } from 'react-i18next'
import { ServicesModalWrapper } from '../../components/Calendar/ReservationModal'
import Flex from 'typescript-styled-flex'
import ModalFlexOverflow from '../../components/Template/Modal/ModalFlexOverflow'
import { is } from '../../components/MediaQuery'
import { useDispatch, useSelector } from 'react-redux'
import { CalendarActions } from '../../reducers/bookingCalendar/actionNames'
import { getSurveyModalOpen } from '../../reducers/bookingCalendar/selectors/calendar'
import { getUserId } from '../../reducers/userAccount/selectors/userAccount'
import styled, { ITheme } from '../../theme'


interface OnboardingVideoModalProps {}

const Wrapper = styled.div`
    width: 40vw;
    height: 50vh;

    @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
        height: 70vh;
        width: calc(100vw - 40px);
    }
`

const OnboardingVideoModal: React.FC<OnboardingVideoModalProps> = () => {
  const { t } = useTranslation()
  const size = useSize()
  const ref = useRef<HTMLDivElement | null>(null)
  const isDesktop = is.desktop()
  const isOpen = useSelector(getSurveyModalOpen)
  const dispatch = useDispatch()
  const userId = useSelector(getUserId)

  const dontShowAgain = () => {
    dispatch({ type: CalendarActions.SetSurveyModalShow })
  }

  const closeModal = () => {
    dispatch({ type: CalendarActions.ToggleSurveyModal, payload: false })
    setTimeout(() => {
      dispatch({type: CalendarActions.OpenOnbordingModal})
    }, 200)
  }


  const close = () => {
    dontShowAgain()
    closeModal()
  }


  return (
    <ModalFlexOverflow open={isOpen} onClose={close}>
      <ServicesModalWrapper>
        <ModalHeader
          style={{
            padding: `${size}em ${0.4 * size}em 0px ${1.3 * size}em`,
            paddingLeft: '15px',
          }}
        >
          <Flex
            style={{ width: '100%' }}
            justifyEnd={true}
            alignCenter={true}
          >
            <CloseButton data-cy={'onboarding-close-button'} onClose={close} />
          </Flex>
        </ModalHeader>

        <Flex
          ref={ref}
          column={true}
          style={{
            fontSize: `${16 * size}px`,
            padding: `15px`,
          }}
        >
          <Wrapper key={'iframe' + isDesktop}>
            <iframe title={'survey'} frameBorder={"0"} id={"iframeX6D3A1V8A8F1F9Y6J"}
              src={t('BED_19323_survey_iframe_code').replace('do_podmiany', String(userId))} height={"100%"} width={"100%"}>
          </iframe>
        </Wrapper>
      </Flex>
    </ServicesModalWrapper>
</ModalFlexOverflow>
)
}

export default OnboardingVideoModal
